import { render, staticRenderFns } from "./CorrespondenciaDashboard.vue?vue&type=template&id=43ac8540&"
import script from "./CorrespondenciaDashboard.vue?vue&type=script&lang=js&"
export * from "./CorrespondenciaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports